<template>
  <div class="relative text-black">
    <button
      @click="onOpen"
      class="sm:w-[34px] sm:h-[34px] flex justify-center items-center group text-blue"
      aria-label="Search"
    >
      <svg
        class="text-beige"
        fill="none"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.96 14.92C11.8039 14.92 14.92 11.8039 14.92 7.96C14.92 4.1161 11.8039 1 7.96 1C4.1161 1 1 4.1161 1 7.96C1 11.8039 4.1161 14.92 7.96 14.92Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
        <path
          d="M18.69 19.82L12.48 13.61"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
      </svg>
    </button>
    <div
      v-if="open"
      class="absolute right-0 top-[55px] w-[390px] max-sm:right-[-108px] max-sm:w-[334px] shadow-header bg-white z-[150] max-sm:top-[42px]"
    >
      <button @click="onOpen" class="absolute left-10 top-[8px] text-blackDark">
        <svg
          class="block h-30 w-30"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.5 7.39355L7.39356 21.5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          ></path>
          <path
            d="M21.5 21.5L7.39356 7.39356"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          ></path>
        </svg>
      </button>
      <input
        ref="inputSearch"
        type="text"
        placeholder="Search"
        v-model="search"
        @input="onInput"
        autofocus
        class="h-45 w-full rounded-r-none border border-blue bg-[#F7F9F9] px-15 pl-40 outline-none placeholder:text-blackDark"
      />
      <div
        class="search-results max-h-[350px] overflow-y-auto border border-t-0 border-blue bg-[#fff] p-10"
      >
        <div v-for="(item, index) in results?.slice(0, 5)" :key="index">
          <div class="flex items-center gap-10 py-10">
            <a :href="item.url">
              <img :src="item.image" class="h-90 w-90 object-cover" />
            </a>

            <a :href="item.url">
              <span class="mb-5 block text-xs"
                >{{ item.opsName || item.sku }}
              </span>
              <span class="block font-medium text-[13px] hover:underline">{{
                item.title
              }}</span>
              <span class="block text-xs hover:underline text-blue">{{
                item.price
              }}</span>
            </a>
            <a
              :href="item.url"
              class="text-navy border-darkBlue hover:text-blue hover:border-blue ml-auto mt-auto mb-auto border flex-[0_0_34px] w-[34px] h-[34px] rounded-full flex justify-center items-center group"
              v-if="build === 'true'"
            >
              <Basket />
            </a>
            <template>
              <button
                v-if="item.available"
                class="text-navy border-darkBlue hover:text-blue hover:border-blue ml-auto mt-auto mb-auto border flex-[0_0_34px] w-[34px] h-[34px] rounded-full flex justify-center items-center group"
                @click.stop="onAddToCart(item.variantId)"
              >
                <Basket />
              </button>
            </template>
          </div>
        </div>
        <div v-if="results.length !== 0" class="flex justify-center">
          <a
            :href="`/search?type=product&q=${search}`"
            class="btn-block-blue flex max-w-[210px] mx-auto my-20"
          >
            View all results
          </a>
        </div>

        <div class="flex flex-col justify-center" v-else>
          <p v-if="search.length !== 0" class="px-10 py-20 text-center">
            No products found for "{{ search }}"
          </p>
          <a
            href="/collections/all"
            class="button mx-auto my-20"
          >
            View all products
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import Basket from "../Icons/Basket";
export default {
  name: "Search",
  props: {
    build: {
      type: String,
    },
  },
  data() {
    return {
      search: "",
      results: [],
      open: false,
    };
  },

  methods: {
    ...mapActions("cart", {
      addItem: "addItem",
    }),
    onInput() {
      const term = this.search.trim();
      const searchURL = `/search/suggest.json?q=${term}&resources[type]=product&resources[options][fields]=title,product_type,variants.title,variants.sku`;

      if (term.length > 3) {
        fetch(searchURL)
          .then(response => response.json())
          .then(data => {
            const products = data.resources?.results?.products || [];

            return Promise.all(
              products.map(product => {
                if (product.variants?.[0]) {
                  return product;
                } else {
                  const productHandle = product.handle;
                  const productDetailURL = `/products/${productHandle}.json`;
                  const ids = window?.Shopify?.hide_product_ids || [];
                  const productsSubscribe =
                    window?.Shopify?.products_subscribe || [];

                  return fetch(productDetailURL)
                    .then(response => response.json())
                    .then(fullProductData => {
                      const productId = fullProductData?.product?.id;
                      const variant = fullProductData?.product?.variants?.[0];
                      const isHidden = ids.includes(String(productId));
                      let opsName = "";
                      if (window?.Shopify?.productOps) {
                        opsName = window?.Shopify?.productOps[productId];
                      }
                      if (isHidden) return null;

                      const subscribeData = productsSubscribe.find(
                        sub => String(sub.id) === String(productId),
                      );

                      const price =
                        subscribeData?.subscribePrice || `$${variant?.price}`;

                      return {
                        ...product,
                        variantId: variant?.id,
                        sku: variant?.sku,
                        price,
                        opsName,
                      };
                    })
                    .catch(error => {
                      console.error(
                        `Error fetching details for ${productHandle}:`,
                        error,
                      );
                      return null;
                    });
                }
              }),
            );
          })
          .then(resultsWithVariantIds => {
            this.results = resultsWithVariantIds.filter(
              product => product !== null,
            );
          })
          .catch(error => {
            console.error(error);
            this.results = [];
          });
      } else {
        this.results = [];
      }
    },
    onOpen() {
      this.open = !this.open;
      this.onFocusInput();
    },
    onAddToCart(varid) {
      this.addItem({id: varid, quantity: 1});
      this.onFocusInput();
    },
    onFocusInput() {
      this.$nextTick(() => {
        if (this.open) {
          this.$refs.inputSearch.focus();
        }
      });
    },
  },
  // mounted() {
  //   console.log(this.build);
  // },
};
</script>
